// extracted by mini-css-extract-plugin
export default {"main":"QuickbookDesktop_main__rOIf5"};